// 100 Steps = 1 Level
export const AUTH_COOKIE_NAME = 'levelup-auth';
export const ADMIN_URL = process.env.REACT_APP_ADMIN_URL || 'http://localhost:3000/admin';
export const APP_ENDPOINT = process.env.REACT_APP_APP_ENDPOINT || 'http://localhost:3001/jobseeker';
export const API_ACCESS_TOKEN = process.env.REACT_APP_API_ACCESS_TOKEN || 'random_token';
export const ADMIN_APP_ENDPOINT = process.env.REACT_APP_ADMIN_URL || 'http://localhost:3000/admin';
export const LEVELUP_AI_APP_ENDPOINT = process.env.REACT_APP_LEVELUP_AI_APP_ENDPOINT || 'https://ai.levelup.inc';
export const STUDENT_APP_ENDPOINT = process.env.REACT_APP_APP_ENDPOINT || 'http://localhost:3001';
export const RECRUITER_APP_ENDPOINT = process.env.REACT_APP_RECRUITER_ENDPOINT || 'http://localhost:3001';
export const UNIVERSITY_APP_ENDPOINT = process.env.REACT_APP_UNIVERSITY_ENDPOINT || 'http://localhost:3001';
export const API_ENDPOINT = process.env.REACT_APP_API_URL || 'http://localhost:8080';
export const ASSESS_PLATFORM_FRONTEND =
	process.env.REACT_APP_ASSESS_PLATFORM_FRONTEND || 'https://assess-test.masaischool.com';
export const ASSESMENT_PLATFROM_CLIENT_ID = process.env.REACT_APP_ASSESMENT_PLATFROM_CLIENT_ID || 'random_Assess_id';
export const RAZORPAY_APP_ID = process.env.REACT_APP_RAZORPAY_APP_ID || 'random_razorpay_id';
export const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || 'https://levelup.masaischool.com';
export const isRecruiterSide = process.env.REACT_APP_SUB_APP === 'recruiter';
export const isUniversitySide = process.env.REACT_APP_UNIVERSITY_APP === 'university';
export const isTestEnv = process.env.REACT_APP_ENVIRONMENT === 'test';
export const allowAllUsers = (process.env.REACT_APP_ALLOW_ALL_USERS || 'false') === 'true';
export const CALENDLY_LINK =
	process.env.REACT_APP_CALENDLY_URL || 'https://calendly.com/levelup-support/levelup-support';
export const LINKEDIN_CLIENT_ID = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
export const ONWARDS_ENDPOINT = process.env.REACT_APP_ONWARDS_ENDPOINT;
export const JOIN_SLACK_URL_FOR_MCL = process.env.REACT_APP_JOIN_SLACK_URL_FOR_MCL;
export const ONWARD_DASHBOARD_BASE_URL =
	process.env.REACT_APP_ONWARD_DASHBOARD_BASE_URL || 'https://dashboard.masaischool.com';
export const DRIVE_API_REFRESH_INTERVAL = Number(process.env.REACT_APP_DRIVE_API_REFRESH_INTERVAL || 5000);
